import {isCanvasNodeType} from '#lit/types/canvas.js';
import type CanvasNode from './index.js';

export function getNodeFromPath(
  composedPath: EventTarget[]
): CanvasNode | null {
  const node = composedPath.find(el => isCanvasNodeType(el)) as
    | CanvasNode
    | undefined;

  return node ?? null;
}
